$(document).ready(function () {
    $("#add-request-by-ti").on('click', function (e) {
        e.preventDefault()
        $("#modal-request-ti").modal('show')
    })

    $("#form-create-request-ti").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendData("/add-request-for-ti",'modal-request-ti',data)
    })

    function sendData(route,modal,data) {
        $.LoadingOverlay("show")
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $.LoadingOverlay("hide")
                    $("#"+modal).modal('hide')
                    if (response.type == "success") {
                        alertSuccess(response.msg)
                        $("#form-create-request-ti")[0].reset()
                        $(".item-branch_id").val('').trigger('chosen:updated')
                        $(".item-software_access").val('').trigger('chosen:updated')

                        $("#requests-ti-table").DataTable().ajax.reload()
                    }
                    if (response.type == "error") {
                        alertError(response.msg)
                    }
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $("#"+modal).modal('hide')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    }
})
